export const emailInvalidText = 'The email provided is not valid';
export const communicationFailedText = 'An error has occurred in trying to communicate with our servers';
